"use client";

import { Button } from "@/components/ui/button";
import { RefreshCcw, Circle } from "lucide-react";
import React from "react";
import { useEffect, useState, useRef } from "react";
import { DebouncedInput } from "@/components/ui/debouncedInput";
import { animate, svg, createScope } from "animejs";

export function DataTableNavBar({ onRefresh, isRefreshing, globalFilter, onFilterChange, lastRefreshTime, autoRefreshDuration }) {
    const [progressValue, setProgressValue] = useState(0);
    const formattedTime = new Date(lastRefreshTime).toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });

    const root = useRef(null);
    const scope = useRef(null);

    useEffect(() => {
        scope.current = createScope({ root }).add((scope) => {
            animate(svg.createDrawable(`.animated circle`), {
                draw: ["0 1"],
                ease: "linear",
                loop: true,
                duration: autoRefreshDuration,
                onLoop: (self) => {
                    onRefresh();
                },
            });

            scope.add("rotateRefreshIcon", (i) => {
                setIsRotating(true);
                animate(".refresh", {
                    rotate: -i * 360,
                    ease: "inOut(4)",
                    duration: 1000,
                    onComplete: (self) => {
                        setIsRotating(false);
                    },
                });
            });
        });

        return () => scope.current.revert();
    }, []);

    const [isRotating, setIsRotating] = useState(false);
    const [rotations, setRotations] = useState(0);
    const handleClick = () => {
        onRefresh();
        const i = rotations + 1;
        setRotations(i);
        scope.current.methods.rotateRefreshIcon(i);
    };

    return (
        <div className="flex flex-col" ref={root}>
            <div className="nav-container relative flex flex-col justify-center">
                <div className="flex w-full justify-center">
                    <div className="flex w-full justify-center items-center space-x-2">
                        <DebouncedInput
                            placeholder="Search by item name or item id"
                            value={globalFilter}
                            onChange={onFilterChange}
                            className="max-w-sm"
                        />
                        <Button variant="outline" onClick={handleClick} disabled={isRotating || isRefreshing}>
                            <RefreshCcw className={`refresh mr-2 h-4 w-4`} />
                            Refresh
                        </Button>
                    </div>

                    <div className="flex items-center gap-2">
                        <div className="flex">
                            <Circle className="background absolute z-1 stroke-3" stroke="var(--color-muted)" />
                            <Circle className="animated z-2 stroke-3" stroke="var(--color-muted-foreground)" />
                        </div>
                        <div className="flex flex-col">
                            <span className="text-xs">Updated</span>
                            <span className="text-xs">{formattedTime}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
